import { useState } from 'react';
import { Layout } from '@/components/generic';
import { useTranslation } from 'react-i18next';

import AuthTransactions from './AuthTransactions';
import CardDetails from './CardDetails';
import CardTransactions from './CardTransactions';
import { CardProvider } from './context/CardContext';
import PhysicalCard from './PhysicalCard';
import Statistics from './Statistics';
import ThreeDSTransactions from './ThreeDSTransactions';
import Banner from './Banner';

type TransactionTab = 'card' | 'auth' | '3ds';

export const Cards = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<TransactionTab>('card');
  return (
    <div className='min-h-screen bg-b-surface1 font-inter text-body-1 text-t-primary antialiased'>
      <Layout title={t('cards.title')}>
        <CardProvider>
          <div className='flex max-lg:flex max-lg:flex-col'>
            <div className='col-left max-lg:order-2 pl-6 max-lg:pl-3'>
              <CardDetails />
              <div className='max-lg:order-3 lg:hidden max-lg:mb-1 mt-6'>
                <PhysicalCard />
              </div>
              <div className='max-lg:order-3 lg:hidden max-lg:mb-1 mt-6'>
                <Banner />
              </div>
              {/* Transactions Card with integrated tabs */}
              <div className='card mt-6'>
                {/* Tabs Navigation inside card header */}
                <div className='flex items-center justify-between border-b border-s-stroke2 px-5 py-3 max-lg:px-3'>
                  <h2 className='text-h6 font-semibold'>{t('cards.transactions')}</h2>
                  <div className='flex gap-1 bg-b-surface2/50 rounded-lg p-1'>
                    <button
                      onClick={() => setActiveTab('card')}
                      className={`px-3 py-1.5 rounded text-sm font-medium transition-all ${activeTab === 'card'
                        ? 'bg-brand-primary dark:text-white shadow-lg ring-1 ring-black/20 dark:ring-white/20'
                        : 'text-t-primary hover:bg-b-surface3/50'
                        }`}
                    >
                      {t('cards.tab_card')}
                    </button>
                    <button
                      onClick={() => setActiveTab('auth')}
                      className={`px-3 py-1.5 rounded text-sm font-medium transition-all ${activeTab === 'auth'
                        ? 'bg-brand-primary dark:text-white shadow-lg ring-1 ring-black/20 dark:ring-white/20'
                        : 'text-t-primary hover:bg-b-surface3/50'
                        }`}
                    >
                      {t('cards.tab_auth')}
                    </button>
                    <button
                      onClick={() => setActiveTab('3ds')}
                      className={`px-3 py-1.5 rounded text-sm font-medium transition-all ${activeTab === '3ds'
                        ? 'bg-brand-primary dark:text-white shadow-lg ring-1 ring-black/20 dark:ring-white/20'
                        : 'text-t-primary hover:bg-b-surface3/50'
                        }`}
                    >
                      {t('cards.tab_3ds')}
                    </button>
                  </div>
                </div>

                {/* Tab Content */}
                <div>
                  {activeTab === 'card' && <CardTransactions />}
                  {activeTab === 'auth' && <AuthTransactions />}
                  {activeTab === '3ds' && <ThreeDSTransactions />}
                </div>
              </div>
            </div>
            <div className='col-right max-lg:order-1'>
              <Statistics />
              <div className='max-lg:hidden'>
                <PhysicalCard />
              </div>
              <div className='max-lg:hidden'>
                <Banner />
              </div>
            </div>
          </div>
        </CardProvider>
      </Layout>
    </div >
  );
};
